import { useEffect, useRef, useState } from "react";
import { Popover, IconButton, Typography, Divider, Box } from "@mui/material";

const IPopover = ({ icon, title = "Popover Title", width = 400, autoOpen = false, onAutoOpen, children }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const buttonRef = useRef(null);
  const open = Boolean(anchorEl);

  // Lets a caller open this without a click, anchored to its own button. onAutoOpen fires so
  // the caller can clear its flag: this component may be conditionally rendered, and a remount
  // would otherwise re-run this effect and reopen the popover.
  useEffect(() => {
    if (autoOpen && buttonRef.current) {
      setAnchorEl(buttonRef.current);
      if (onAutoOpen) onAutoOpen();
    }
  }, [autoOpen]);

  return (
    <>
      <IconButton ref={buttonRef} color="primary" onClick={(e) => setAnchorEl(e.currentTarget)}>
        {icon}
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          sx: {
            p: 2,
            borderRadius: 2,
            // A hard minWidth (500 for the buy engine's advanced config) is wider than a
            // phone viewport and pushes the popover off screen. Below sm it is clamped to
            // the viewport instead; from sm up the original min/max are untouched.
            width: { xs: "calc(100vw - 24px)", sm: "auto" },
            minWidth: { xs: 0, sm: width },
            maxWidth: { xs: "calc(100vw - 24px)", sm: width + 100 },
            maxHeight: { xs: "72vh", sm: "none" },
            overflowY: { xs: "auto", sm: "visible" },
            boxShadow: 4,
          },
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", color: "primary.main", mb: 1 }}>
          {title}
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Box>{children}</Box>
      </Popover>
    </>
  );
};

export default IPopover;
